webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    beforeCreate: function beforeCreate() {
        var _this = this;

        var activeUser = this.$kinvey.User.getActiveUser();
        if (!activeUser || !this.$store.state.activeUser) {
            console.log('no login');
            this.$kinvey.User.login({
                username: 'guest',
                password: 'guest'
            }).then(function (user) {
                console.log('login!');
                _this.$store.commit('getActiveUser', user);
                // this.$root.reload();
                window.location.reload();
                // this.$router.replace({ path: '/', query: { user: 'guest' } });
            });
        }
    }
});

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_core_css__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_bubble_css__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_bubble_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_bubble_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            title: '',
            ctx: {},
            quill: {},
            type: '',
            ctxId: '',
            loading: true
        };
    },

    methods: {},
    mounted: function mounted() {
        var _this = this;

        var dataStore = this.$kinvey.DataStore.collection('articles', this.$kinvey.DataStoreType.Network);
        this.ctxId = this.$route.query.id;
        this.quill = new __WEBPACK_IMPORTED_MODULE_0_quill___default.a('#editor', {
            readOnly: true,
            theme: 'bubble'
        });
        var stream = dataStore.findById(this.ctxId);
        stream.subscribe(function (res) {
            if (res) {
                _this.title = res.title;
                _this.ctx = res.content;
                _this.type = res.type;
                _this.quill.setContents(_this.ctx);
                _this.loading = false;
            } else {
                console.log('can not find article');
            }
        }, function (err) {
            console.log(err);
        });
    }
});

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_quill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_core_css__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_core_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_quill_dist_quill_core_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_snow_css__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_snow_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_quill_dist_quill_snow_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            title: '',
            ctx: {},
            quill: {},
            types: [{
                value: '情感',
                label: '情感'
            }, {
                value: '生活',
                label: '生活'
            }, {
                value: '运动',
                label: '运动'
            }],
            type: ''
        };
    },

    methods: {
        update: function update() {
            this.ctx = this.quill.getContents();
        },
        handleCommitCtx: function handleCommitCtx() {
            var _this = this;

            var articles = this.$kinvey.DataStore.collection('articles');
            var article = {
                title: this.title,
                type: this.type,
                content: this.ctx
            };
            articles.save(article).then(function (res) {
                _this.$router.push({ path: 'article', query: { id: res._id } });
            }).catch(function (err) {
                console.log(err);
            });
        }
    },
    mounted: function mounted() {
        var toolbarOptions = [['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
        [{ 'direction': 'rtl' }], // text direction
        [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
        [{ 'font': [] }], [{ 'align': [] }], ['clean'], // remove formatting button
        ['link', 'image']];
        this.quill = new __WEBPACK_IMPORTED_MODULE_0_quill___default.a('#editor', {
            modules: {
                toolbar: toolbarOptions
            },
            theme: 'snow'
        });
        this.quill.on('text-change', this.update);
    }
});

/***/ }),

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_avatar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'blog-header',
    components: {
        'avatar': __WEBPACK_IMPORTED_MODULE_0_vue_avatar___default.a
    },
    methods: {
        handleLogout: function handleLogout() {
            var _this = this;

            this.$kinvey.User.logout().then(function () {
                _this.$store.commit('getActiveUser', null);
                _this.$router.replace('/');
            });
        }
    },
    data: function data() {
        return {
            username: '书香墨剑'
        };
    },
    mounted: function mounted() {
        //   this.username = this.$store.state.activeUser.username;
    }
});

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Login',
    data: function data() {
        return {
            signUp: {
                username: '',
                password: '',
                email: ''
            },
            signIn: {
                username: '',
                password: ''
            },
            dialogVisible: false
        };
    },

    methods: {
        alertError: function alertError(errorCode) {
            switch (errorCode) {
                case 409:
                    this.$alert('该用户已经存在', '\u9519\u8BEF' + errorCode);
                    break;
                case 401:
                    this.$alert('用户名或密码出错啦!', '\u9519\u8BEF' + errorCode);
                    break;
                default:
                    this.$alert('未知错误', '\u9519\u8BEF' + errorCode);
                    break;
            }
        },
        handleSignIn: function handleSignIn() {
            var _this = this;

            this.$kinvey.User.login({
                username: this.signIn.username,
                password: this.signIn.password
            }).then(function (activeUser) {
                _this.$store.commit('getActiveUser', activeUser);
                _this.$router.replace('/editor');
            }).catch(function (err) {
                console.log(err);
                _this.alertError(err.code);
            });
        },
        handleSignUp: function handleSignUp() {
            var _this2 = this;

            var user = new this.$kinvey.User();
            user.signup({
                username: this.signUp.username,
                password: this.signUp.password,
                email: this.signUp.email,
                first_name: 'public'
            }).then(function (activeUser) {
                _this2.$store.commit('getActiveUser', activeUser);
                _this2.dialogVisible = false;
                _this2.$alert('赶快登录写下你的文章吧', '恭喜你,注册成功!', {
                    callback: function callback() {
                        _this2.$router.replace('/post');
                    }
                });
            }).catch(function (error) {
                _this2.alertError(error.code);
            });
        }
    },
    mounted: function mounted() {
        var activeUser = this.$kinvey.User.getActiveUser();
        if (activeUser !== null) {
            this.$store.commit('getActiveUser', activeUser);
            this.$router.replace('/post');
        }
    }
});

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Post',
    data: function data() {
        return {
            userId: '',
            userList: [],
            subjectList: [],
            postList: [],
            subject: 'all',
            fullscreenLoading: true
        };
    },

    methods: {
        listArticle: function listArticle() {
            var _this = this;

            // const userId = this.userId;
            // const query = new this.$kinvey.Query();
            // query.equalTo('_acl.creator', userId);
            // query.fields = ['_id', 'title', 'type'];
            var dataStore = this.$kinvey.DataStore.collection('articles');
            dataStore.find().subscribe(function (res) {
                var subjectList = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(res), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var val = _step.value;

                        val.type = val.type === '' ? val.type = '未分类' : val.type;
                        if (subjectList.indexOf(val.type) === -1) {
                            subjectList.push(val.type);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                _this.subjectList = subjectList;
                _this.postList = res;
                if (_this.postList.length > 0) {
                    _this.fullscreenLoading = false;
                }
                // console.log(res);
            }, function (err) {
                console.log(err);
            });
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.$router.push({ path: 'article', query: { id: val._id } });
        },
        handleSubjectChange: function handleSubjectChange(subject) {
            this.subject = subject;
        }
    },
    mounted: function mounted() {
        this.listArticle();
    }
});

/***/ }),

/***/ 161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 162:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 165:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 168:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(165)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(181),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(182),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-737ebe2c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(168)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(184),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 179:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('blog-header'), _vm._v(" "), _c('el-input', {
    staticClass: "title-input",
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "slot": "prepend",
      "filterable": "",
      "allow-create": "",
      "placeholder": "分类"
    },
    slot: "prepend",
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "size": "large",
      "icon": "upload"
    },
    on: {
      "click": _vm.handleCommitCtx
    },
    slot: "append"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "editor"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 180:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('el-row', {
    staticClass: "continer",
    attrs: {
      "type": "flex",
      "align": "middle",
      "gutter": 70
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 7,
      "sm": 5,
      "md": 4,
      "lg": 2
    }
  }, [_c('avatar', {
    staticClass: "imgAvatar",
    attrs: {
      "username": _vm.username
    }
  })], 1), _vm._v(" "), _c('el-col', [_c('h2', [_vm._v(_vm._s(_vm.username) + "'s Blog")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 181:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('div', {
    attrs: {
      "id": "editor"
    }
  })])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 182:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "content"
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": {
        span: 6,
        offset: 9
      }
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n            欢迎登陆\n        ")]), _vm._v(" "), _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "用户名",
      "type": "text"
    },
    model: {
      value: (_vm.signIn.username),
      callback: function($$v) {
        _vm.$set(_vm.signIn, "username", $$v)
      },
      expression: "signIn.username"
    }
  }), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "密码",
      "type": "password"
    },
    model: {
      value: (_vm.signIn.password),
      callback: function($$v) {
        _vm.$set(_vm.signIn, "password", $$v)
      },
      expression: "signIn.password"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSignIn
    }
  }, [_vm._v("登陆")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "注册",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.signUp
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.signUp.username),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "username", $$v)
      },
      expression: "signUp.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.signUp.email),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "email", $$v)
      },
      expression: "signUp.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.signUp.password),
      callback: function($$v) {
        _vm.$set(_vm.signUp, "password", $$v)
      },
      expression: "signUp.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSignUp
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 183:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 184:
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "continer"
  }, [_c('blog-header'), _vm._v(" "), _c('el-col', {
    staticClass: "menu-vertical",
    attrs: {
      "xs": 7,
      "sm": 4,
      "md": 4,
      "lg": 3
    }
  }, [_c('el-menu', {
    attrs: {
      "default-active": "-1"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "-1"
    },
    on: {
      "click": function($event) {
        _vm.handleSubjectChange('all')
      }
    }
  }, [_vm._v("全部")]), _vm._v(" "), _vm._l((_vm.subjectList), function(subject, index) {
    return _c('el-menu-item', {
      key: index,
      attrs: {
        "index": '' + index
      },
      on: {
        "click": function($event) {
          _vm.handleSubjectChange(subject)
        }
      }
    }, [_vm._v(_vm._s(subject))])
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content",
    attrs: {
      "xs": 17,
      "sm": 20,
      "md": 20,
      "lg": 21
    }
  }, [_c('el-tabs', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }]
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.postList.filter(function (post) {
        if (this$1.subject === 'all') {
          return true;
        } else {
          return (post.type === _vm.subject)
        }
      }),
      "stripe": "",
      "show-header": false,
      "row-key": _vm.postList.id
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "listTime"
        }, [_vm._v(_vm._s(scope.row.time))]), _vm._v(" "), _c('span', {
          staticClass: "listTitle"
        }, [_vm._v(_vm._s(scope.row.title))])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 66:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Post__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Post___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Post__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Article__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Article__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/login',
        name: 'Login',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Login___default.a
    }, {
        path: '/',
        name: 'Post',
        component: __WEBPACK_IMPORTED_MODULE_3__components_Post___default.a
    }, {
        path: '/editor',
        name: 'Editor',
        component: __WEBPACK_IMPORTED_MODULE_4__components_Editor___default.a
    }, {
        path: '/article',
        name: 'Article',
        component: __WEBPACK_IMPORTED_MODULE_5__components_Article___default.a
    }]
}));

/***/ }),

/***/ 70:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(45);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        activeUser: null
    },
    mutations: {
        getActiveUser: function getActiveUser(state, user) {
            state.activeUser = user;
        }
    }
}));

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(167)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(183),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(180),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b05cf48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_kinvey_html5_sdk__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_kinvey_html5_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_kinvey_html5_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Header__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Header__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var AppKey = 'kid_BJVrF0RKW';
var AppSecret = '4cac002c973f44278b1c42787f3c8893';


__WEBPACK_IMPORTED_MODULE_6_kinvey_html5_sdk__["Kinvey"].init({
    appKey: AppKey,
    appSecret: AppSecret
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$kinvey = __WEBPACK_IMPORTED_MODULE_6_kinvey_html5_sdk__["Kinvey"];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('BlogHeader', __WEBPACK_IMPORTED_MODULE_8__components_Header___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_2__App___default.a
    }
});

/***/ })

},[99]);


// WEBPACK FOOTER //
// static/js/app.46d75746c0c0ddd4dedc.js